import IndicadoresAps from '../pages/IndicadoresAps/Index.vue'

import ResultadoIndicadores from '../pages/IndicadoresAps/ResultadoIndicadores/ResultadoIndicadores'

import ResultadoIsfAcs from '../pages/IndicadoresAps/ResultadoIsf/ResultadoIsfAcs'

import DesempenhoPorEquipe from '../pages/IndicadoresAps/DesempenhoPorEquipe'
import DesempenhoPorEquipeGeral from '../pages/IndicadoresAps/DesempenhoPorEquipe/Geral'
import DesempenhoPorEquipePorIndicador from '../pages/IndicadoresAps/DesempenhoPorEquipe/PorIndicador'

export default [
  {
    path: '/indicadores-aps',
    component: IndicadoresAps,
  },
  {
    path: '/resultado-indicadores',
    component: ResultadoIndicadores,
  },
  {
    path: '/resultado-isf-acs',
    component: ResultadoIsfAcs,
  },
  {
    path: '/desempenho-por-equipe',
    component: DesempenhoPorEquipe,
  },
  {
    path: '/desempenho',
    component: () =>
      import('@/pages/IndicadoresAps/DesempenhoPorEquipe/Template.vue'),
    children: [
      {
        path: '/desempenho-por-equipe/geral',
        component: DesempenhoPorEquipeGeral,
      },
      {
        path: '/desempenho-por-equipe/indicador',
        component: DesempenhoPorEquipePorIndicador,
      },
    ],
  },
  {
    path: '/indicadores-aps/resultado-municipal',
    component: () =>
      import('@/pages/IndicadoresAps/ResultadoMunicipal/Template.vue'),
    children: [
      {
        path: '/indicadores-aps/resultado-municipal',
        component: () =>
          import('@/pages/IndicadoresAps/ResultadoMunicipal/Index.vue'),
      },
    ],
  },
  {
    path: '/indicadores-aps/divergencia-dados-indicadores',
    component: () =>
      import('@/pages/IndicadoresAps/DivergenciaDadosIndicadores/Index.vue'),
  },
]
